<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Create New {{mode == 'C' ? 'Checklist': 'Action Item'}}</h3>
</div>
<div class="modal-body">
    <p>
        Select a {{mode == 'C' ? 'checklist': 'action item'}} template:
    </p>
    <ng-select [(ngModel)]="formData.selectedTemplate"
               [clearable]=false
               [searchable]="!mobileMode"
               dropdownPosition="bottom">
        <ng-option *ngFor="let data of templates" [value]="data.ChecklistTemplateID">{{data.DisplayValue}}</ng-option>
    </ng-select>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="createClicked()" [disabled]="formData.selectedTemplate == null">Create</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>